'use client';

import { usePlausible } from 'next-plausible';
import { usePostHog } from 'posthog-js/react';
import type { MouseEvent } from 'react';

import { Link, type Props as LinkProps } from '@/components/Link/Link';
import { segment } from '@/lib/tracking/segmentAnalytics';

interface Props extends Omit<LinkProps, 'onClick'> {
    eventName: string;
    eventProperties?: Record<string, unknown>;
    plausibleEventName?: string;
}

export function TrackedLink({ eventName, eventProperties, plausibleEventName, ...props }: Props) {
    const posthog = usePostHog();
    const plausible = usePlausible();

    function handleClick(event: MouseEvent) {
        posthog.capture(eventName, eventProperties);
        segment.track(eventName, eventProperties);
        if (plausibleEventName) {
            plausible(plausibleEventName, {
                props: {
                    href: event.currentTarget.getAttribute('href'),
                    label: event.currentTarget.textContent,
                    ...eventProperties,
                },
            });
        }
    }

    return <Link {...props} onClick={handleClick} />;
}
